import React, { useEffect, useState } from "react";
import { Box, Popover, Typography, IconButton } from "@mui/material";
import { IoClose } from "react-icons/io5";
import Hr from "@/Components/Buttons/Hr";
import { useUser } from "@/Context/UserContext";

export default function SummaryPopover({
  open,
  anchorEl,
  onClose,
  title = "Summary",
}) {

  const { formData,exporterMasterId,importerMasterId,eximData } = useUser()
  const [productDetails, setProductDetails] = useState({})

  useEffect(() => {
    if (!open) return; 

    const isExport = Boolean(exporterMasterId)
    const productArray = formData?.["productMain"];
    const invoiceArray = formData?.["invoiceMain"]
    if (Array.isArray(productArray) && productArray.length > 0) {
      const selectedProduct =
      productArray.find((item) => item.selected) || productArray[0];
      const selectedInvoice = invoiceArray?.find((item) =>item.selected) || invoiceArray[0]
      
      const productEximCode = eximData?.find((item) =>item?.id === selectedProduct?.eximCode)?.name
      console.log(selectedProduct, "selectedProduct",productEximCode);
      if (selectedProduct) {
        setProductDetails({
          productNo: isExport ? selectedProduct?.exportProductMainDescriptionId?.name : selectedProduct?.importProductMainDescription?.name ||  "-",
          invoiceNo: selectedInvoice?.srNo || "-",
          amount: isExport ? selectedProduct?.exportProductMainAmount : selectedProduct?.importProductMainAmount ||  "-",
          eximScheme:   productEximCode,
          ritcCode: isExport ? selectedProduct?.exportProductMainRITCorHSNCodeId?.name : selectedProduct?.importProductMainCTHorHSNCode?.name  || "-",
          totalAmount: selectedProduct?.totalAmount || 0,
        });
      }
    } else {
      setProductDetails({});
    }
    
    console.groupEnd();
  }, [formData["productMain"], open]);
  
  return (
    <Popover
      open={open}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "left",
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "left",
      }}
      PaperProps={{
        sx: {
          border: "1px solid var(--gray-300)",
          borderRadius: "12px",
          boxShadow: 4,
          width: 400,
        },
      }}
    >
      <Box>
        {/* Header with title and close */}
        <Box
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          px={3}
          py={1}
        >
          <Typography variant="bodyStrong" sx={{ color: "var(--gray-900)" }}>
            {title}
          </Typography>
          <IconButton onClick={onClose}>
            <IoClose fontSize="24px" color="var(--brand-950)" />
          </IconButton>
        </Box>

        {/* Total Amount */}
        <Hr sx={{ mb: 1.5, mt: 0 }}></Hr>
        <Typography
          variant="subheading"
          sx={{ mb: 1, color: "var(--gray-700)", px: 3 }}
        >
          Total Amount:{" "}
          <Typography
            variant="subheadingBold"
            component="span"
            color="var(--gray-900)"
          >
            {productDetails.totalAmount || 0} USD
          </Typography>
        </Typography>

        {/* Product Details Banner */}
        <Box
          sx={{
            backgroundColor: "var(--brand-200)",
            height: 40,
            mt: 1.5,
            display: "flex",
            alignItems: "center",
            px: 3,
          }}
        >
          <Typography variant="bodyStrong">Current Product Details</Typography>
        </Box>

        {/* Fields Section */}
        <Box display="flex" flexDirection="column" gap={3} mt={2} px={3}>
          <Box display="flex" gap={10}>
            <Box display="flex" flexDirection="column">
              <Typography variant="bodyBase">Product</Typography>
              <Typography variant="bodyMedium">
                {productDetails.productNo || "-"}
              </Typography>
            </Box>
            <Box display="flex" flexDirection="column">
              <Typography variant="bodyBase">Invoice</Typography>
              <Typography variant="bodyMedium">
                {productDetails.invoiceNo || "-"}
              </Typography>
            </Box>
          </Box>

          <Box display="flex" gap={11}>
            <Box display="flex" flexDirection="column">
              <Typography variant="bodyBase">Amount</Typography>
              <Typography variant="bodyMedium">
                {productDetails.amount || "-"}
              </Typography>
            </Box>
            <Box display="flex" flexDirection="column">
              <Typography variant="bodyBase">Exim Scheme</Typography>
              <Typography variant="bodyMedium">
                {productDetails.eximScheme || "-"}
              </Typography>
            </Box>
          </Box>

          <Box display="flex" flexDirection="column" mb={3}>
            <Typography variant="bodyBase">RITC Code</Typography>
            <Typography variant="bodyMedium">
              {productDetails.ritcCode || "-"}
            </Typography>
          </Box>
        </Box>
      </Box>
    </Popover>
  );
}
